import { createContext } from 'react';

export const DisableDeviceContext = createContext();
export const DisableDeviceDispatchContext = createContext();
